import { useEffect } from 'react';
import DeepLinking from 'modules/deep-linking/deep-linking';
import { useAuthContext } from 'store/context/auth/auth-context';
import { usePatientsContext } from 'store/context/patient-context';

const GetWebviewMessage = () => {
  const { isLoggedIn } = useAuthContext();
  const { setNativeToken } = usePatientsContext();

  const extractUserToken = (event) => {
    if (event && typeof event.data === 'string') {
      const data = JSON?.parse(event?.data);
      if (data?.state === 'deeplinkingDetails') {
       const id = data?.params || {};
        if (id?.length > 0) {
          setNativeToken(id);
        }
      }
    }
  };

  const PostMessage = (event) => {
    extractUserToken(event);
  };

  const GetShareLinkToken = (event) => {
    extractUserToken(event);
  };

  useEffect(() => {
    window?.ReactNativeWebView?.postMessage('getShareToken');
    document.addEventListener('message', PostMessage);
    window.addEventListener('message', PostMessage);

    document.addEventListener('message', GetShareLinkToken);
    window.addEventListener('message', GetShareLinkToken);

    return () => {
      document.addEventListener('message', PostMessage);
      window.addEventListener('message', PostMessage);
      document.removeEventListener('message', GetShareLinkToken);
      window.removeEventListener('message', GetShareLinkToken);
    };
  }, []);

  return isLoggedIn && <DeepLinking />;
};

export default GetWebviewMessage;
